// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/scuba-diving.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/scuba-diving/scuba-diving.js';

mount([g0]);
